import { useMemo } from 'react';
import { useLocation, useParams } from 'react-router';

import { useAppSelector } from '@/App/hooks';
import { selectSeoDefaults } from '@/features/config/selectSeoDefaults';
import { selectSeoMetas } from '@/features/config/selectSeoMetas';
import { selectLocale } from '@/features/i18n/selectLocale';
import { removePathParamByValue } from '@/helpers/removePathParamByValue';

export const useSeoMeta = () => {
  const locale = useAppSelector(selectLocale);
  const { pathname } = useLocation();
  const { locale: localeParam } = useParams();
  const seoMetas = useAppSelector(selectSeoMetas);
  const seoDefaults = useAppSelector(selectSeoDefaults);

  return useMemo(() => {
    if (locale) {
      const path = localeParam ? removePathParamByValue(pathname, localeParam) : pathname;
      const paths = seoMetas[locale];
      return (paths && paths[path]) || seoDefaults[locale];
    }
    return null;
  }, [locale, localeParam, pathname, seoMetas, seoDefaults]);
};
